import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SuperadminHeader } from "../components/superadmin/SuperadminHeader";

export const Route = createFileRoute("/superadmin/security-logs")({
  component: SuperadminSecurityLogsLayout,
});

function SuperadminSecurityLogsLayout() {
  return (
    <div className="flex h-screen flex-col bg-background">
      <SuperadminHeader
        title="Security Logs"
        subtitle="Auth and access events"
      />

      {/* Content */}
      <main className="flex-1 overflow-auto p-6">
        <div className="container mx-auto max-w-6xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
